import React, { useEffect } from 'react';
import { useDarkMode } from '../../contexts/DarkModeContext';
import { FaGraduationCap, FaUsers, FaLightbulb, FaRocket, FaHeart, FaGlobe, FaCode, FaFlask, FaAtom, FaStar } from 'react-icons/fa';
import './AboutUs.css';

const AboutUs = () => {
  const { isDarkMode } = useDarkMode();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const stats = [
    { number: '5000+', label: 'طالب نشط', icon: <FaUsers /> },
    { number: '100+', label: 'معلم محترف', icon: <FaGraduationCap /> },
    { number: '200+', label: 'تجربة تفاعلية', icon: <FaFlask /> },
    { number: '98%', label: 'رضا الطلاب', icon: <FaHeart /> }
  ];

  const features = [
    {
      icon: <FaRocket />,
      title: 'تعليم تفاعلي',
      description: 'نقدم تجارب تفاعلية متطورة تساعد الطلاب على فهم المفاهيم العلمية بسهولة'
    },
    {
      icon: <FaLightbulb />,
      title: 'منهج مبتكر',
      description: 'منهج تعليمي مبتكر يجمع بين النظرية والتطبيق العملي'
    },
    {
      icon: <FaGlobe />,
      title: 'تقنية متطورة',
      description: 'نستخدم أحدث التقنيات في التعليم الإلكتروني'
    },
    {
      icon: <FaCode />,
      title: 'منصة ذكية',
      description: 'منصة تعليمية ذكية تتكيف مع مستوى كل طالب'
    }
  ];



  const values = [
    {
      icon: <FaHeart />,
      title: 'التميز',
      description: 'نسعى دائماً للتميز في كل ما نقدمه من خدمات تعليمية'
    },
    {
      icon: <FaLightbulb />,
      title: 'الابتكار',
      description: 'نبتكر حلول تعليمية جديدة ومتطورة'
    },
    {
      icon: <FaGlobe />,
      title: 'الشمولية',
      description: 'نؤمن بأن التعليم حق للجميع بغض النظر عن المكان'
    },
    {
      icon: <FaUsers />,
      title: 'التعاون',
      description: 'نعمل معاً كفريق واحد لتحقيق أهدافنا التعليمية'
    }
  ];

  return (
    <div className={`about-us-page ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
      {/* Hero Section */}
      <section className="about-us-hero">
        <div className="about-us-container">
          <div className="about-us-hero-content">
            <div className="about-us-hero-text">
              <h1 className="about-us-hero-title">
                من نحن
                <span className="about-us-hero-subtitle">علمني</span>
              </h1>
              <p className="about-us-hero-description">
                منصة تعليمية رائدة تهدف إلى جعل التعليم العلمي أكثر تفاعلية ومتعة.
                نقدم تجارب افتراضية متطورة تساعد الطلاب على فهم المفاهيم العلمية
                بطريقة عملية ومشوقة.
              </p>
              <div className="about-us-hero-buttons">
                <a href="/subjects" className="about-us-btn about-us-btn-primary">ابدأ التعلم</a>
                <a href="/labs" className="about-us-btn about-us-btn-secondary">شاهد التجارب</a>
              </div>
              
            </div>
            <div className="about-us-hero-visual">
            
              <div className="about-us-hero-image">
                <img src="/elementary-student-has-idea.jpg" alt="علمني" className="about-us-hero-img" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="about-us-stats">
        <div className="about-us-container">
          <div className="about-us-stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="about-us-stat-card">
                <div className="about-us-stat-icon">{stat.icon}</div>
                <div className="about-us-stat-number">{stat.number}</div>
                <div className="about-us-stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="about-us-features">
        <div className="about-us-container">
          <div className="about-us-section-header">
            <h2 className="about-us-section-title">ما يميزنا</h2>
            <p className="about-us-section-description">
              نقدم تجربة تعليمية فريدة تجمع بين التكنولوجيا المتطورة والمحتوى العلمي المتميز
            </p>
          </div>
          <div className="about-us-features-grid">
            {features.map((feature, index) => (
              <div key={index} className="about-us-feature-card">
                <div className="about-us-feature-icon">{feature.icon}</div>
                <h3 className="about-us-feature-title">{feature.title}</h3>
                <p className="about-us-feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

   
      {/* Mission Section */}
      <section className="about-us-mission">
        <div className="about-us-container">
          <div className="about-us-mission-content">
            <div className="about-us-mission-text">
              <h2 className="about-us-mission-title">رسالتنا</h2>
              <p className="about-us-mission-description">
                نسعى إلى توفير تعليم علمي عالي الجودة ومتاح للجميع،
                من خلال استخدام التكنولوجيا الحديثة لتطوير مهارات التفكير
                العلمي والإبداع لدى الطلاب.
              </p>
              <div className="about-us-mission-values">
                <div className="about-us-mission-value">
                  <FaHeart className="about-us-mission-value-icon"  />
                  <span>التميز</span>
                </div>
                <div className="about-us-mission-value">
                  <FaStar className="about-us-mission-value-icon" />
                  <span>الابتكار</span>
                </div>
                <div className="about-us-mission-value">
                  <FaGlobe className="about-us-mission-value-icon" />
                  <span>الشمولية</span>
                </div>
              </div>
            </div>
            <div className="about-us-mission-visual">
              <div className="about-us-mission-graphic">
                <FaGraduationCap className="about-us-mission-graphic-icon" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs; 